module.exports = __webpack_public_path__ + "img/newokr-icon.303ff8f6.svg";